import O1HD, {modules} from "../../engines/gameEngine";
import {REWARD_TYPE} from "../../engines/services/userContent/userInterface";
import data_control from "../../engines/libs/data_control";
import gameConfig from "../../engines/configs/gameConfig";
import { PLATFORM_CODE } from "../../engines/services/ossService";
import PromiseUtil from "../../engines/libs/PromiseUtil";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import UserDataManage from "../../modes/normalMode/model/UserDataManage";
import { OpenOreSpecialCollect } from "../../modes/normalMode/prefab/openOreGame/openOreConst";
import utilsView from "../../engines/libs/utilsView";
import { CsvFileKind } from "../../modes/define/CsvFileKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class coin extends cc.Component {

    @property(cc.Label)
    lbCoin: cc.Label = null;

    onLoad() {
        O1HD.on("changeMoney" , this.changeMoney , this );
    }

    start() {
        PromiseUtil.nextFrame().then(()=> {
            O1HD.getManagers().gameMgr.loadChaoPiaoPos(this.node.convertToWorldSpaceAR(cc.v2()));
        });
    }

    OnBtnAddCoins() {
        modules().uiControlModule.showUserPropGet(REWARD_TYPE.COIN, gameConfig.ADD_ONCE_COINS);
    }

    update(dt) {
        this.lbCoin.string = data_control.getNumberFormat(O1HD.getServices().userSrv.getCoins(), 1 );
    }

    /**
     * 添加金币
     */
    onBtnAddCoinsTest() {
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            // O1HD.getServices().userSrv.setCoins(100000, true);
            O1HD.getServices().userSrv.setCoins(100000000, true);

            // let gameData = NormalGameManager._instance.getGameData();
            // gameData.taskDataMap = {};
            // NormalGameManager._instance.writeGameData();

            // let gameData = NormalGameManager._instance.getGameData();

            // gameData.wechatRecordPoint.push('5040Finish');
            // gameData.bFinishHitRob = false;
            // let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
            // let matchMiaiData = matchMiaiDataManage.matchMiaiData;
            // matchMiaiData.ownEquipList.splice(matchMiaiData.ownEquipList.length-1, 1);

            // for (let i = 0; i< 28; i++) {
            //     NormalGameManager._instance.taskDataManage.addNewTask(i + '');
            // }
            // O1HD.getServices().userSrv.setCoins(12000, true);

            // let gameData = NormalGameManager._instance.getGameData();
            // gameData.bShowSuperPowerBtn = true;
            // NormalGameManager._instance.writeGameData();

            
            // O1HD.getServices().userSrv.setCoins(-27000, true);
            //// 测试代码
            // NormalGameManager._instance.onPushGoods(50045, 1);
            // NormalGameManager._instance.onPushGoods(11001, 10);
            
            // NormalGameManager._instance.onPushGoods(50013, 1);
            // NormalGameManager._instance.onPushGoods(50045, 1);
            // NormalGameManager._instance.onPushGoods(50014, 1);
            // NormalGameManager._instance.onPushGoods(50015, 1);
            // NormalGameManager._instance.onPushGoods(50016, 1);
            // let gameData = NormalGameManager._instance.getGameData();
            // gameData.nvWaStore = new Array(5).fill(true);
            // NormalGameManager._instance.writeGameData();
                

            // let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
            // let matchMiaiData = matchMiaiDataManage.matchMiaiData;
            // matchMiaiData.bBridePrice = true;
            // matchMiaiData.ownEquipList.push('6');
    
            // utilsView.openEventLayer(
            //     null
            //     , {
            //         id: '9'
            //         , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
            //         , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
            //         , saveData: ()=> {
                       
            //         }
            //         , exitLayer: ()=> {
                        
            //         }
            //     }
               
            // );
        }
    }

    //改变金钱
    changeMoney( changeMoneyNum : number ){
        let tempNode : cc.Node = null;
        if ( changeMoneyNum > 0 ) {
            if ( this.node.getChildByName("lbAdd") ) {
                tempNode = cc.instantiate( this.node.getChildByName("lbAdd"));
                tempNode.getComponent(cc.Label).string = `+${changeMoneyNum}`;
            }
        }else{
            if ( this.node.getChildByName("lbReduce") ) {
                tempNode = cc.instantiate( this.node.getChildByName("lbReduce"));
                tempNode.getComponent(cc.Label).string = `${changeMoneyNum}`;
            }
        }
        //
        if ( tempNode ) {
            this.node.addChild( tempNode );
            tempNode.active = true;
            cc.tween( tempNode )
                .by( 1.5 , { y : 20 ,opacity : 50 })
                .call(()=>{
                    tempNode.removeFromParent();
                    tempNode.destroy();
                })
                .start();
        }
    }
}
